import { render } from "./MainContent.vue?vue&type=template&id=43d5d514&scoped=true"
import script from "./MainContent.vue?vue&type=script&lang=js"
export * from "./MainContent.vue?vue&type=script&lang=js"

import "./MainContent.vue?vue&type=style&index=0&id=43d5d514&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-43d5d514"

export default script